export const INSURANCE_DESCLAIMER = `
  תנאי פוליסת הביטוח
בהתאם לתנאי הפוליסה,

· הכיסוי יסתיים עם הפריקה בנמל. במידה והרכב יובל על גבי מובילית עד לבית הלקוח, הכיסוי יסתיים בבית הלקוח.

· אין כיסוי לצד ג', גוף או רכוש.

· אין כיסוי כאשר הרכב נוסע בכוחות עצמו להוציא פעולות השינוע ע"י עובדי הנמל.

· השתתפות עצמית במקרה נזק או אובדן 1% מסכום הביטוח מינימום 500$.



הפוליסה הנמכרת היא מסוג CLAUSE C.

הכיסוי מסעיפי המכון לביטוח מטענים "C" - נזק תאונתי של הכלי המוביל

(אש,התהפכות,התנגשות,התפוצצות)

מורחב לכסות אובדן כללי של הרכב.



**חשוב מאד  ***

המערכת נותנת אפשרות לביטוח רק כולל המיסים, מכיוון שבעת נזק, כאשר מחושבת ירידת ערך לרכב, הסכום נגזר מערך הרכב כולל המיסים.

· הכיסוי יסתיים עם הפריקה בנמל. במידה והרכב יובל על גבי מובילית עד לבית הלקוח, הכיסוי יסתיים בבית הלקוח.

· אין כיסוי לצד ג', גוף או רכוש.

· אין כיסוי כאשר הרכב נוסע בכוחות עצמו להוציא פעולות השינוע ע"י עובדי הנמל.



תנאי הביטוח המלאים הם בהתאם למדיניות חברת הביטוח כפי שיוגדרו בפוליסה.



** ישנה אפשרות לרכוש כיסוי ביטוחי, ללא מיסי הכניסה. זה לא מומלץ.

    אם ברצונכם לרכוש כיסוי מופחת, אנא פנו אלינו בכתב.
`;

export const TermsText = `
החלוקה ל4 איזורים בגרמניה היא לנוחיותכם בלבד, באם יהיה מקרה שבו איזור האיסוף שיוזן הוא לא מדויק או נמצא על על התפר ונדרש בעלות שונה,

העלות שתקבע היא העלות הגבוהה מביניהם, ובכל מקרה, תאושר לפני לפני תיאום הרכב.

המחיר מארה"ב מתייחס להובלה במכולה 20'. ריקון המכולה לא כלול במחיר.

המחירים אינם כוללים הוצאות כגון: הובלה בארץ, בדיקות מכס, הנפקת רישיונות ואישורים, אחסנות/השהיות, מע"מ ומיסים כחוק, מס נמל, סבלות, מנוף, המתנה וכו'.
המחירים כפופים לשינויים של חברות התעופה/ספנות/נמל ואינם ישימים לחומרים מסוכנים.
SlickChain פועלת להסדרת השילוח הבינלאומי ומשמשת כגורם מתאם בלבד לצורך ענייני הלוגיסטיקה וההובלה הימית / יבשתית, ולפיכך אינה אחראית לשינויי נתיב ההובלה ו/או משך ההובלה ו/או איחורים בהגעה ו/או במסירת המטען ו/או נזק/חוסר שייגרמו בעת שהמטען אינו בחזקתה בפועל של החברה. פרטי הטיסה/הפלגה ולוחות הזמנים הינם משוערים בלבד, בהתאם לנתונים הנמסרים ע"י חברת התעופה/ספנות וכפופים לשינויים המבוצעים על ידן.
אחריותה של החברה מוגבלת על פי האמנות הבינלאומיות הרלבנטיות או על פי שטר המטען, אם הוצא על ידי החברה, לרבות לעניין תקופות ההתיישנות וגובה האחריות.
לחברתנו תהיה זכות עיכבון על כל סוג של משלוחים ו/או נכסים, להבטחת התשלומים המגיעים לחברתנו מכם, לרבות תשלומים בגין משלוחים קודמים.
חישוב עלות המיסים ועלות ההובלה הינו משוער בלבד, העלות הסופית תקבע במעמד השחרור ממכס ישראל.
תנאי תשלום – מזומן לפני השחרור, אלא אם כן סוכם אחרת בכתב.
הסחורה אינה מבוטחת, למעט רכישת פוליסת ביטוח דרך המערכת.`;


export const TermsTextEuStandard = `מדובר במידע ראשוני בלבד, ואינו מחייב.
קבלת או אי קבלת הפטור מדמי המכס, תלויים אך ורק בעמידה בכל ההנחיות ונתון לשיקול דעתו הבלעדי של המכס, בהתאם לחיקוק ולהסכמי הסחר הרלוונטיים.
SlickChain אינה אחראית לאמיתות המידע ולהשלכות בגין שימוש בכלי בדיקה זה.
האחריות לבדיקת אמיתות המידע ולהשלכות משימוש במידע, הם על המשתמש בלבד.
בלחיצה על כפתור אישור זה, המשתמש מאשר וקרא והבין את האמור.`;


export const TermsTextCarsStandard = `1.\tסליקצ'יין שרשרת אספקה דיגיטלית בע"מ ("החברה") המפעילה מערכת מקוונת להצגת מלאי הרכבים, הנמצא מחוץ לישראל, הכוללת את הערכת העלות הכוללת של הרכב לאחר שחרור מכס בישראל, שינוע דיגיטלי ושחרור מרשות מכס ישראל באמצעות ספקי רכב, חברות הובלה וסוכני מכס חיצוניים ("המערכת").

2.\tהחברה אינה פועלת כ"מתווך ביבוא אישי" עפ"י הגדרתו  ב:"חוק רישוי שירותים ומקצועות בענף הרכב, תשע"ו-2016"  ("חוק רישוי") ואינה מספקת כל ייעוץ ו/או הדרכה ו/או שירות פעיל של איתור של רכב כלשהוא.

3.\tמשתמשי המערכת רשאים לסקור את מלאי הרכבים הנמצא במערכת (שאינו בבעלות החברה), ובהנחה שיבקשו לרכוש רכב שפרטיו מופיעים במערכת, עפ"י שיקול דעתם הבלעדי בלבד ו/או יבקשו להיעזר בשירותיו של "מתווך ביבוא אישי" מוסמך ובעל רשיון בתוקף, החברה תדאג לספק להם שירות שכזה, זאת עפ"י הוראות כל דין ועפ"י המוגדר בחוק רישוי.

4.\tכל תשלום עבור עלות הרכב במדינת המקור ו/או מיסי היבוא ישולם במלואו ישירות מחשבונו של יבואן הרכב האישי למוכר הרכב מחוץ לישראל ו/או ישירות לסוכן המכס ו/או ישירות לרשות המיסים וזאת בהלימה מלאה לסעיף 34 לחוק רישוי.

5.\tהמשתמש מצהיר בזאת כי הוא מודע לעובדה שכל תפקידה של החברה בקשר עם ספקי הרכב ו/או ספקי השינוע הבינלאומי ו/או סוכני המכס ו/או נותני שירותים שונים הינו לשמש כגורם מתאם בלבד לצורך ענייני תפעול שינוע ו/או שחרור הרכבים מרשות המכס בישראל ו/או שירותים שונים שעיקרם רישום הרכב לנסיעה בישראל. לפיכך, החברה אינה אחראית לשינויי נתיב ההובלה ו/או משך ההובלה ו/או איחורים בהגעה ו/או במסירת הרכב ו/או נזק ו/או חוסר שייגרמו לרכב.

6.\tהמשתמש מצהיר בזאת כי הוא מודע לעובדה כי הפלגה, כמו גם לוחות הזמנים בקשר לשירותי החברה הינם משוערים בלבד, בהתאם לנתונים הנמסרים ע"י חברת הספנות וכפופים לשינויים המבוצעים על ידן. על כן, המשתמש מצהיר בזאת כי לא תהיה לו כל תלונה ו/או טענה כלפי החברה בעיכובים כאלה ואחרים אשר אינן בשליטה של החברה בקשר עם יבוא הרכבים ושילוחם ליבואן.

7.\tמובהר בזאת, כי כלל האחריות הן לגבי ייצור הרכב, פגמים ברכב, עיכובים בייצור, עיכובים בשילוח וכל היוצא בזאת הינה באחריות יצרן הרכב ו/או ספק הרכב, חברות ההובלה היבשתית, המחסנים, נמלי הים, וחברות הספנות איתן עובדת החברה.

8.\tמובהר בזאת כי החברה עושה כל שביכולתה לתת למשתמש הצעת מחיר אשר תהיה מדויקת וקרובה ככל שניתן לעלות הסופית של הלקוח בקשר עם עלות הרכב, היבוא ו/או השילוח.
עם זאת, ראוי לציין כי חישוב עלות המיסים ועלויות הובלת הרכב הינם משוערים בלבד שכן ישנם גורמים אשר החברה אינה יכולה לצפות מראש כגון: מיסים ואגרות ממדינת היצוא, בדיקות מכס בנמל הטעינה, השטעון ו/או הפריקה, שינוי של שערי החליפין במטבעות זרים מזמן הזמנת הרכב ועד מעמד שחרור הרכב, שינויים של מחירי השינוע על ידי חברות הספנות, עלויות בלתי צפויות בנמלי הים, עלויות אחסנה, השהייה, פסילת ערך עסקה והוצאת גרעון בגין הפרש מיסים לתשלום על ידי מכס ישראל, בזמן הליך שחרור ובדיעבד, תשלום של קנסות וכופר המושתים ע"י המכס ו/או משרד התחבורה, וכו'.

9.\tהמשתמש מצהיר בזאת כי הוא מודע לכך שהעלות הסופית עבור השירות הנבחר תקבע במעמד שחרור הרכב מהמכס בישראל בלבד (למעט פסילת ערך בדיעבד, גם במקרה של פסילת "מסמך העדפה", והוצאת גרעון בגין הפרש מיסים לתשלום על ידי מכס ישראל ו/או תשלום של קנסות ו/או כופר המושתים על ידי המכס ו/או משרד התחבורה), כמו כן מובהר בזאת כי שיערוך העלויות אינו כולל הוצאות כגון: הובלה יבשתית בישראל, בדיקות מכס, הנפקת רישיונות ואישורים, אחסון ו/או השהיות, סבלות, מנוף, המתנה, התקנות, שמאות רכב, תקינה, וכל הוצאה אחרת כל שהיא לאחר שחרור הרכב מרשות המכס.

10.\tמובהר בזאת כי במידה ולא יוסדר התשלום על ידי הלקוח בעבור מי משירותי החברה אותם הוא רכש, החברה שומרת לעצמה את הזכות לעכב כל סוג של משלוח ו/או רכב של משתמש וזאת לצורך הבטחת הסדרת התשלום בעבור השירותים שסופקו על ידה, לרבות תשלומים בגין עסקאות ו/או משלוחים קודמים.

11.\tאין לראות במידע המופיע באתר משום הבטחה כלשהי ו/או אחריות לטיב הרכבים ו/או לטיב שירות החברות שהן חלק משרשרת האספקה שאיתן עובדת החברה.

12.\tהחברה לא תהיה אחראית לשום נזק, ישיר או עקיף, אשר ייגרם למשתמש כתוצאה מהסתמכות על מידע המופיע באתר ו/או בקישורים לאתרים אחרים ו/או כל מקור מידע פנימי ו/או חיצוני אחר ו/או שימוש בשירותים אשר מוצגים על ידו.

13.\tהחברה לא תהיה אחראית לכל נזק (ישיר או עקיף), הפסד, עגמת נפש והוצאות שייגרמו למשתמשים ו/או לצדדים שלישיים כלשהם בעקבות שימוש או הסתמכות על כל תוכן, מידע, נתון, מצג, תמונה, וידאו, אודיו, פרסומת, מוצר, שירות וכיוצא בזה המופעים באתר ובפרט לא תהיה אחראית לאמינות הפרטים אודות הרכבים אשר הועלו לאתר ולא לטיב התמונות אשר בקשר עם רכבים מסוימים.

14.\tכל הסתמכות כאמור נעשית על-פי שיקול דעתו ואחריותו הבלעדית של המשתמש באתר ושל האנשים אשר השאירו פרטיהם בקשר עם שירותי החברה והרכבים אותם הם בחרו לייבא ולשלח לישראל.

15.\tהאתר ממליץ למשתמשים באתר לנהוג בזהירות, ולקרוא בעיון את המידע המוצג באתר ובכלל זה את המידע ביחס לשירות עצמו, תיאורו והתאמתו.

16.\tהאתר בכללותו, לרבות כל המידע המופיע בו, מוצע לציבור כמות שהוא, ויהיה מדויק ונכון ככל הניתן, ואולם, יתכן והמידע אינו שלם או לחלופין, יתכן ונפלו טעויות טכניות או אחרות במידע.

17.\tשימוש באתר ייעשה על אחריותו הבלעדית והמלאה של כל משתמש. כל החלטה שתתקבל ביחס לתכנים שיתפרסמו באתר הינה באחריותו המלאה של המשתמש. האתר אינו מתחייב כי התכנים המתפרסמים באתר, יהיו מלאים, נכונים, חוקיים או מדויקים או יהלמו את ציפיותיו ודרישותיו של כל משתמש. האתר לא יישא באחריות כלשהי לכל תוצאה שתנבע מהם, או משימוש בהם, או מהסתמכות עליהם.
`;


export const TermsTextSubscription = `
1.\tהתשלום הוא עבור הזכות להשתמש במחשבון מיסי היבוא וההובלה בלבד.

2.\tחברת סליקצ'יין שרשרת אספקה דיגיטלית בע"מ ("מפעילת האתר") אינה אחראית, אינה מתחייבת ואינה יכולה להתחייב לסכום הסופי שבו יחוייבו עלות ההובלה ו/או מיסי היבוא ו/או עלויות נוספות כגון: בדיקות מכס, אחסנה, השהייה, פסילת ערך יבוא ע"י המכס, שערי מטבע משתנים, קנסות יבוא.

3.\tהשימוש במחשבון מיסי היבוא וההובלה הינו על באחריות המשתמש בלבד.

4.\tהפירוט של מרכיבי החישוב הינם לצורך המחשה בלבד, ואינם מחייבים את מפעילת האתר.

5.\tהתחשבות ו/או התבססות על נתוני החישוב באתר הינם באחריותו הבלעדית של המשתמש ולא יחייבו את מפעילת האתר.

6.\tהתשלום החודשי ("מינוי") הוא עבור כל מחזור חיוב שמתחיל ביום אישור פרטי כרטיס האשראי ומתחדש כל חודש בחודשו עד לביטולו הייזום של המינוי ע"י המשתמש.

7.\tלאחר תחילת מחזור חיוב, במידה והמשתמש מבקש לבטל את המינוי, המינוי יתבטל החל ממחזור החיוב הבא לאחר מכן. * ביטול המינוי בתקופה של 7 ימי עסקים לפני חידוש מחזור החיוב תחשב כביטול שלא במועד כך שביטול החיוב המתחדש יתבצע רק בחודש שלאחריו.

8.\tאין אפשרות לבטל ולא לקבל זיכוי מלא או חלקי עבור מינוי שנתי.

9.\tפרטי המינוי אינם ניתנים להעברה, מפעילת האתר שומרת לעצמה את הזכות לבטל מינוי ולחסום גישה לאתר ולמחשבון באם משתמש יפר כלל זה.

`;


export const TermsTextArbitrage = `
"מחיר שוק משוער" הינו מחיר משוקלל משלל נתונים, המחיר הוא לצורכי התייחסות בלבד ואינו משקף את המחיר הנמוך ביותר הניתן להשיג עבור הרכב הזה.
יתכנו משתנים שלא ניתן להכניס לשקלול באופן אוטומטי העלולים להשפיע על המחיר באופן דרמטי. מפעילת האתר מבקשת שכל החלטה שתילקח בעקבות התבססות על המידע המוצג תיבדק בעוד מקורות מידע על מנת להגיע להחלטה המושכלת ביותר. בכל מקרה אין מפעילת האתר אחראית על כל נזק ישיר או עקיף שיגרם כתוצאה מכל פעולה שנעשית באתר ביחד למחיר המוצג.

`;

